import { safeParseDate } from './DateUtilities';
/* eslint-disable @typescript-eslint/naming-convention */
export function processUserRelationship(rawUserRelationship) {
    if (!rawUserRelationship) {
        return undefined;
    }
    return {
        last_access_datetime: safeParseDate(rawUserRelationship.last_access_datetime),
        last_modified_datetime: safeParseDate(rawUserRelationship.last_modified_datetime),
        last_shared_by_id: rawUserRelationship.last_shared_by_id,
        last_shared_datetime: safeParseDate(rawUserRelationship.last_shared_datetime),
        save_for_later_datetime: safeParseDate(rawUserRelationship.save_for_later_datetime),
        last_shared_by_history: rawUserRelationship.last_shared_by_history,
        last_shared_display_name: rawUserRelationship.last_shared_display_name,
        last_action_datetime: safeParseDate(rawUserRelationship.last_action_datetime),
    };
}
//# sourceMappingURL=processUserRelationship.js.map